// extracted by mini-css-extract-plugin
module.exports = {"dashboardPageContainer":"styles_dashboardPageContainer__2YvSd","alignLeft":"styles_alignLeft__26Qht"};